import * as Sentry from '@sentry/browser';
import jsmediatags from 'jsmediatags';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import App from './App';
import StartupBoundary from './components/common/errorBoundary/startupBoundary';
import { beforeBreadcrumb, beforeSend } from './services/sentryScrub';
import './styles/index.scss';
import { sentryDsn } from './config';

if (process.env.NODE_ENV === 'development') {
  (window as any)['jsmediatags'] = jsmediatags;
}

if (process.env.NODE_ENV === 'production' && sentryDsn) {
  // Error reporting must never be able to take the app down. Ad blockers
  // routinely refuse the ingest endpoint (uBlock Origin does, out of the
  // box), and the SDK copes with that on its own - but the app has no
  // business depending on the outcome either way, so the one call that
  // could conceivably throw is fenced off.
  try {
    Sentry.init({
      dsn: sentryDsn,
      // Both hooks, not just beforeSend: the Drive file ids were mostly in
      // breadcrumbs, which record every fetch url automatically.
      beforeBreadcrumb,
      beforeSend,
    });
  } catch (err) {
    console.error('Sentry initialisation failed, continuing without it', err);
  }
}

createRoot(document.getElementById('root')!).render(
  <StartupBoundary>
    <Router>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Router>
  </StartupBoundary>,
);
